import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { SANTA_MEMBERS_APP_ID } from '../../constants/applications';
import Wix from '../../services/wix-sdk-polyfill';

const MembersAreaLink = ({ appDefinitionId, appPageId, onClick, children, viewedUser, ...props }) => {
  const linkProps = omit(props, 'dispatch');

  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    Wix.getPublicAPI({ appDefinitionId: SANTA_MEMBERS_APP_ID }, api => {
      api.navigateToSection({
        appDefinitionId,
        appPageId,
        viewedUser,
      });
    }, console.error);
  };

  return (
    <a onClick={handleClick} href="#" {...linkProps}>
      {children}
    </a>
  );
};

MembersAreaLink.propTypes = {
  appDefinitionId: PropTypes.string,
  appPageId: PropTypes.string,
  children: PropTypes.node,
  viewedUser: PropTypes.string,
  onClick: PropTypes.func,
};

export default MembersAreaLink;



// WEBPACK FOOTER //
// ./app/components/link/members-area-link.js